import { defineMessages } from "react-intl";

export const messages = defineMessages({
  productTypeName: {
    id: "H5yp8O",
    defaultMessage: "Product Type Name",
    description: "label",
  },
  optionNormalTitle: {
    id: "xRbqcg",
    defaultMessage: "Regular product type",
    description: "option",
  },
  optionGiftCardTitle: {
    id: "kp2IYP",
    defaultMessage: "Gift card product type",
    description: "option",
  },
  optionGiftCardDescription: {
    id: "7nKXni",
    defaultMessage: "This product will act as a payment method",
    description: "option description",
  },
});
